import React from 'react';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import { IconButton } from '@mui/material';
import FilterAltRoundedIcon from '@mui/icons-material/FilterAltRounded';
import { COLOR } from '@src/styles/color';

const AdvancedFilterButton = ({ setOpenFilter, isFiltering }) => (
  <div>
    <IconButton onClick={() => setOpenFilter(true)} className="filter-btn">
      <FilterAltRoundedIcon sx={{ color: COLOR.navyBlue, fontSize: '24px' }} />
      {isFiltering && (
        <FiberManualRecordRoundedIcon
          className="circle-btn"
          sx={{ color: COLOR.textPending, fontSize: '16px !important' }}
        />
      )}
    </IconButton>
  </div>
);

export default AdvancedFilterButton;
